import { createSlice } from "@reduxjs/toolkit"

interface initialStateI {
    lstCursos: [];
    cursoDisponible: [];
    cursoSelecccionado: number | null;
    openModalInscripcion: boolean;
    enviado: boolean;
    mostrarLstCursos: boolean;
    inscrito: boolean;
    loadingEnviado: boolean;
    irInscripcion: boolean;

}
const initialState: initialStateI = {
    lstCursos: [],
    cursoDisponible: [],
    cursoSelecccionado: null,
    openModalInscripcion: false,
    enviado: false,
    mostrarLstCursos: false,
    inscrito: false,
    loadingEnviado: false,
    irInscripcion: false,

}
export const inscripcionCursosSlice = createSlice({
    name: 'inscripcionCursosSlice',
    initialState,
    reducers: {
        onSetLstCursos: (state, { payload }) => {
            state.lstCursos = payload;
        },
        onSetCursoDisponible: (state, { payload }) => {
            state.cursoDisponible = payload;
        },
        onSetCursoSeleccionado: (state, { payload }) => {
            state.cursoSelecccionado = payload;
        },
        onSetOpenModalInscripcion: (state, { payload }) => {
            state.openModalInscripcion = payload;
        },
        onSetEnviado: (state, { payload }) => {
            state.enviado = payload;
        },
        onSetMostrarLstCursos: (state, { payload }) => {
            state.mostrarLstCursos = payload;
        },
        onSetInscrito: (state, { payload }) => {
            state.inscrito = payload;
        },
        onSetLoadingEnviado: (state, { payload }) => {
            state.loadingEnviado = payload;
        },
        onSetIrInscripcion: (state, { payload }) => {
            state.irInscripcion = payload;
        },
    },
});

export const {
    onSetLstCursos,
    onSetCursoDisponible,
    onSetCursoSeleccionado,
    onSetOpenModalInscripcion,
    onSetEnviado,
    onSetMostrarLstCursos,
    onSetInscrito,
    onSetLoadingEnviado,
    onSetIrInscripcion,
} = inscripcionCursosSlice.actions;